export const PSI = {
    root: 'product-detail-size-info',
    accordion: 'product-detail-size-info__accordion',
    accordionSummary: 'product-detail-size-info__accordion-summary',
    accordionDetails: 'product-detail-size-info__accordion-details',
    tableWrap: 'product-detail-size-info__table-wrap',
    table: 'product-detail-size-info__table',
} as const;
